import React from 'react'

import DefaultLink from '../../../components/DefaultLink'

export default function TechnologyNex({ technex }) {
  return (
    <>
      <section className='tech-nex'>
        <div className='container'>
          <div className='row justify-content-between'>
            {technex.map((item, index) => (
              <div className='col-lg-4 col-md-6' key={index}>
                <div className='tech-nex-box' >
                  <img src={item?.img} alt="previous" />
                  <h3>{item?.title}</h3>
                  <DefaultLink to={item?.slug} text={index === 0? "See Previous" : "See Next"} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section >
    </>
  )
}
